import { Skeleton } from '@/components/ui/skeleton';

const INITIAL_SKELETON_ROWS = 4;

export const ApplicationRowSkeleton = () => (
  <li className="flex items-center gap-3 py-3">
    <Skeleton className="size-8 shrink-0 rounded-lg" />
    <div className="grow space-y-1.5">
      <Skeleton className="h-3.5 w-40" />
      <Skeleton className="h-3 w-24" />
    </div>
    <Skeleton className="h-6 w-20" />
  </li>
);

const ApplicationsListSkeleton = () => (
  <ul data-testid="applications-list-skeleton" className="divide-y divide-border px-6">
    {Array.from({ length: INITIAL_SKELETON_ROWS }, (_, index) => (
      <ApplicationRowSkeleton key={index} />
    ))}
  </ul>
);

export default ApplicationsListSkeleton;
